var _SerializerTokensRegistry_nodes, _SerializerTokensRegistry_marks;
import { __classPrivateFieldGet } from "tslib";
import { MarkdownSerializer } from './markdown/MarkdownSerializer';
export class SerializerTokensRegistry {
    constructor() {
        _SerializerTokensRegistry_nodes.set(this, {});
        _SerializerTokensRegistry_marks.set(this, {});
    }
    addNode(name, node) {
        __classPrivateFieldGet(this, _SerializerTokensRegistry_nodes, "f")[name] = node;
        return this;
    }
    addMark(name, mark) {
        __classPrivateFieldGet(this, _SerializerTokensRegistry_marks, "f")[name] = mark;
        return this;
    }
    createSerializer() {
        return new MarkdownSerializer(__classPrivateFieldGet(this, _SerializerTokensRegistry_nodes, "f"), __classPrivateFieldGet(this, _SerializerTokensRegistry_marks, "f"));
    }
}
_SerializerTokensRegistry_nodes = new WeakMap(), _SerializerTokensRegistry_marks = new WeakMap();
